
import { useUsersStore } from '@/stores/users';

export default (to, from, next) => {
  const userStore = useUsersStore();
  // excecao se for admin
  if(userStore.isAdmin) {
    next();
    return;
  }
  // se a permissao for igual a 1 entao todos podem acessar
  if(to.meta?.permission === 1) {
    next();
    return;
  }
  // senao for admin, ele tem a permissao de acessar o modulo (string ou lista OR)
  if (to.meta.module) {
    const modules = Array.isArray(to.meta.module) ? to.meta.module : [to.meta.module]
    if (modules.some((module) => userStore.getPermissions.includes(module))) {
      next();
      return;
    }
  }

  next({ name: 'expired-blocked' });
};
